import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

/**
 * @description This function lets you return component according to the name of the incoming action.
 * @param       action - object
 * @param       variables - object variable list
 * @param       setOpenVariable - open variable function that allows us to open
 * @param       variableRenbder - variable render
 * @Returns     Component
 * @Author      Onur Döğücü
 */
function SetCellFormula({
    action,
    variables,
    setOpenVariable
}) {
    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.EXCEL.SET-CELL-FORMULA.";

    useEffect(() => {
        // Assign initial values
        if (!action.fields.formula) {
            action.fields.formula = { value: '', isRequired: true };
        }

        if (!action.fields.range) {
            action.fields.range = { value: '', isRequired: true };
        }
    }, [action]);

    return (
        <>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'EXCEL-SOURCE')} is_required />
                <VariablePicker action={action} inputName="excelSource" variables={variables}
                    setOpenVariable={setOpenVariable} filter="data table" isRequired hideRequired />
                <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'RANGE')} is_required />
                <TextInput action={action} inputName="range" variables={variables} setOpenVariable={setOpenVariable}
                    isRequired hideRequired />
                <small className="conf-field-desc"><em>{t(label + 'RANGE-EG')}</em></small>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'FORMULA')} is_required />
                <TextInput action={action} inputName="formula" variables={variables} setOpenVariable={setOpenVariable}
                    isRequired hideRequired />
                <small className="conf-field-desc"><em>{t(label + 'JUST-EN-FORMULE')}</em></small>
            </div>
        </>
    )
}

export default SetCellFormula;
